// Layout
import Section from './layout/section'
// Styles
import styles from './client-text.module.scss'

interface ClientTextProps {
  clientText?: string
  isClientHeaderHtml?: boolean
}

const ClientText = ({
  clientText,
  isClientHeaderHtml = false,
}: ClientTextProps) => {
  if (!clientText) return null

  return isClientHeaderHtml
    ? (
      <nav
        dangerouslySetInnerHTML={{__html: clientText}}
        className={styles['client-header']}
      ></nav>
    )
    : (
      <Section
        styleModifiers={[
          '--is-div',
          '--is-display-block',
          '--is-centered-horizontally',
        ]}
      >
        <div
          dangerouslySetInnerHTML={{__html: clientText}}
          className={styles['client-text']}
        ></div>
      </Section>
    )
}

export default ClientText
